import {
    MapOptions
} from "@esdm/map/dist";
import { CheshireBaseLayerTypes } from "./CheshireBaseMapping_27700";

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [
            CheshireBaseLayerTypes.CheshireOS,
            CheshireBaseLayerTypes.CheshireAerial
            ,
            CheshireBaseLayerTypes.CheshireAerial2000
            ,
            CheshireBaseLayerTypes.CheshireAerial1970
            /*,
            CheshireBaseLayerTypes.CheshireAerial1945,
            CheshireBaseLayerTypes.CheshireOS6inchEpoch1,
            CheshireBaseLayerTypes.CheshireOS6inchEpoch2*/,
            CheshireBaseLayerTypes.CheshireTitheMaps
        ];
        opt.defaultBaseMap = CheshireBaseLayerTypes.CheshireOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 14;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 10;
        opt.minZoom = 9;
        opt.maxZoom = 16;
        
        opt.extent = [324700, 338800, 401900, 398500];
        opt.mapCentre = [
            //Cheshire centroid
            364512, 368373
        ];    

        opt.displayProjection = "EPSG:27700";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;                
        return opt;
    }

}
